import React from 'react'
import { FormHelperText, useTheme } from '@material-ui/core'

export default ({ children }) => {
  const theme = useTheme()

  if (!children) {
    return null
  }

  return (
    <FormHelperText error css={{ marginBottom: theme.spacing(3) }}>
      {children}
    </FormHelperText>
  )
}
